import { accessTokenManager as accessTokenManagerLegacy } from './accessTokenManagerLegacy';
import { accessTokenManager as accessTokenManagerExperimental } from './accessTokenManagerExperimental';

export const accessTokenManager = localStorage.getItem('experimentalauth')
  ? accessTokenManagerExperimental
  : accessTokenManagerLegacy;

export { getAccountsDomain, login, logout, changeAccount } from './accounts';
